export const DOCUMENT_TYPE = {
  nationalid: 'RUN',
  passport: 'Pasaporte',
  temporal: 'RUN',
};
